import { reducer as account } from 'components/Account'
import { reducer as collections } from 'components/Collections'
import { reducer as notifications } from 'components/Notifications'
import { combineReducers } from 'redux'

import { reducer as app } from './app'
import { reducer as map } from './map'
import { reducer as pdc } from './pdc'
import { reducer as routePlanner } from './routePlanner'
import { reducer as search } from './search'
import { reducer as user } from './user'

export const rootReducer = combineReducers({
  account,
  app,
  collections,
  map,
  notifications,
  pdc,
  routePlanner,
  search,
  user,
})
export type RootState = ReturnType<typeof rootReducer>
